import * as React from "react";

import { useLocalization } from "@shared-ui/localization-context";

import { UitkFakeInput } from "uitk-react-input";
import { UitkSpacing } from "uitk-react-spacing";

import { withStores } from "src/stores";
import {
  FlexTrackingInfo,
  sendImmediateClickstreamTrackEvent,
  Action,
} from "src/components/utility/analytics/FlexAnalyticsUtils";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";

const SINGLE_SEARCH_ENTRY = "SingleSearchEntry";

export const SingleSearchEntry: React.FC = withStores("wizardState")(({ children, wizardState }) => {
  const [displayForms, setDisplayForms] = React.useState(false);
  const track = useClickTracker();
  const { formatText } = useLocalization();

  const { labelKey } = wizardState.globalWizardState.config.singleSearchEntryTrigger;
  const label = formatText(labelKey);

  const flexTracking: FlexTrackingInfo = {
    moduleName: SINGLE_SEARCH_ENTRY,
    rfrr: `wizard.simple`,
    action: Action.CLICK,
  };

  const onSearchForProductsButtonClick = () => {
    setDisplayForms(true);
    sendImmediateClickstreamTrackEvent(flexTracking, track);
  };

  return (
    <>
      {!displayForms && (
        <UitkSpacing padding="six">
          <div>
            <UitkFakeInput
              onClick={onSearchForProductsButtonClick}
              label={label}
              icon="search"
              id="single-search-entry-trigger"
              data-testid="single-search-entry-trigger"
            />
          </div>
        </UitkSpacing>
      )}

      {displayForms && children}
    </>
  );
});
